import { GoogleGenerativeAI } from '@google/generative-ai';
import { Slide, SlideContentItem } from '../types';
import { createSlideRegenerationPrompt } from '../constants/slidePrompts';

export async function regenerateSlideContent(
  slide: Slide,
  prompt: string,
  apiKey: string,
  language: 'ko' | 'en' = 'ko'
): Promise<{ title: string; content: string; structuredContent?: SlideContentItem[] }> {
  const genAI = new GoogleGenerativeAI(apiKey);
  const model = genAI.getGenerativeModel({ model: 'gemini-2.0-flash-lite' });

  // 기존 프롬프트 대신 slidePrompts.ts의 함수 사용
  const systemPrompt = createSlideRegenerationPrompt(
    slide.title,
    slide.content,
    prompt,
    language
  );

  try {
    const result = await model.generateContent(systemPrompt);
    const response = await result.response;
    const text = response.text();

    // JSON 응답 파싱 시도
    try {
      // JSON 응답에서 ```json이나 기타 마크다운 제거
      let cleanResponse = text.trim();
      if (cleanResponse.startsWith('```json')) {
        cleanResponse = cleanResponse.replace(/^```json\s*/, '').replace(/\s*```$/, '');
      } else if (cleanResponse.startsWith('```')) {
        cleanResponse = cleanResponse.replace(/^```\s*/, '').replace(/\s*```$/, '');
      }
      
      const jsonResponse = JSON.parse(cleanResponse);
      if (Array.isArray(jsonResponse)) {
        console.log('Successfully parsed JSON response for regeneration:', jsonResponse);
        
        // JSON 응답에서 제목과 내용 추출
        const titleObj = jsonResponse.find(item => item.category === 'title');
        const contentObjs = jsonResponse.filter(item => item.category === 'content');
        
        const title = titleObj ? titleObj.content : slide.title;
        // Content를 텍스트로 변환 (배열인 경우 처리)
        let content = slide.content;
        if (contentObjs.length > 0) {
          content = contentObjs.map(obj => {
            if (Array.isArray(obj.content)) {
              return obj.content.join('\n');
            }
            return obj.content;
          }).join('\n\n');
        }
        
        return { title, content, structuredContent: jsonResponse };
      }
    } catch (jsonError) {
      console.warn('Failed to parse JSON response, falling back to text parsing:', jsonError);
    }

    // 텍스트 파싱 폴백 (기존 로직)
    const lines = text.split('\n');
    let title = slide.title;
    let content = slide.content;
    let isContent = false;

    for (const line of lines) {
      if (line.startsWith('제목:') || line.startsWith('Title:')) {
        title = line.replace(/^(제목:|Title:)\s*/, '').trim();
      } else if (line.startsWith('내용:') || line.startsWith('Content:')) {
        content = line.replace(/^(내용:|Content:)\s*/, '').trim();
        isContent = true;
      } else if (isContent && line.trim()) {
        content += '\n' + line.trim();
      }
    }

    return { title, content };
  } catch (error) {
    console.error('Failed to regenerate slide:', error);
    throw new Error('슬라이드 재생성에 실패했습니다.');
  }
}